/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import LegalDocumentPage from "../components/LegalDocumentPage";

const sections = [
  {
    title: "Agreement",
    body:
      "By accessing or using Volta Software websites, applications, or services (including Qurated, WednesdayClub, and related products), you agree to these Terms & Conditions. If you do not agree, do not use our services.",
  },
  {
    title: "Use of services",
    body:
      "You agree to use our services only for lawful purposes and in a way that does not infringe the rights of others or restrict their use of the services. You may not attempt to gain unauthorized access to our systems, interfere with service operation, or misuse content or features.",
  },
  {
    title: "Accounts",
    body:
      "Some products require an account. You are responsible for keeping your credentials secure and for activity under your account. We may suspend or terminate access if we reasonably believe these terms have been violated.",
  },
  {
    title: "Content and intellectual property",
    body:
      "Volta Software and its licensors retain ownership of software, branding, and site content unless otherwise stated. User-submitted content (such as reviews or profile information) remains yours, but you grant us a license to host, display, and process it as needed to operate the service.",
  },
  {
    title: "Disclaimers",
    body:
      "Services are provided “as is” and “as available” without warranties of any kind, whether express or implied, including fitness for a particular purpose or uninterrupted availability, to the extent permitted by law.",
  },
  {
    title: "Limitation of liability",
    body:
      "To the fullest extent permitted by law, Volta Software is not liable for indirect, incidental, special, or consequential damages arising from your use of our services. Our total liability for any claim related to the services is limited to the amount you paid us for the service in the twelve months before the claim, if any.",
  },
  {
    title: "Changes",
    body:
      "We may update these terms from time to time. Continued use after changes are posted constitutes acceptance of the revised terms.",
  },
  {
    title: "Contact",
    body: "Questions about these terms can be sent to admin@voltasoftware.net.",
  },
];

function TermsVoltaSoftware() {
  return <LegalDocumentPage title="Terms & Conditions" sections={sections} />;
}

export default TermsVoltaSoftware;
